import type { IListCacheOriginal } from "@adgm/cross-models";
import { aesEncrypt, aesDecrypt } from "./common";
import Storage from "./Storage.app";

/**
 * 缓存数据加密存储
 * @param key 缓存键
 * @param data 待缓存数据
 * @returns Promise<unknown>
 */
export const setCacheData = (key: string, data: unknown): Promise<unknown> => {
  const caches: IListCacheOriginal = {};
  caches[key] = aesEncrypt(key, JSON.stringify(data));
  return Storage.save<IListCacheOriginal>(key, caches);
};

/**
 * 缓存数据解密读取
 * @param key 缓存键
 * @returns Promise<unknown>
 */
export const getCacheData = async (key: string): Promise<unknown> => {
  const _aesDecryptData = (await Storage.load<IListCacheOriginal>(key)) ?? {};
  const cryptoText = _aesDecryptData?.[key];
  const jsonText = cryptoText ? aesDecrypt(key, cryptoText) : undefined;
  return JSON.parse(jsonText ?? "{}");
};
